import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Container from './PrivacyStatementContent.styled';

const useStyles = makeStyles((theme) => ({
  content: {
    'height': '100%',
    'paddingRight': theme.spacing(2),
    'margin-bottom': '200px',
  },
  closeBtn: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
  },
  title: {
    marginBottom: theme.spacing(3),
  },
  subheader: {
    fontWeight: 500,
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(0.5),
  },
  paragraphLastChanged: {
    marginTop: theme.spacing(6),
    fontStyle: 'italic',
  }
}));

const PrivacyStatementContent = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  const getLastModifiedText = () => {
    const date = t('privacy-statement.date-last-modified');
    const str = t('privacy-statement.content.paragraph-last-changed', { 'date-last-modified': date });
    return str;
  };

  return (
    <Container>
      <Box className={classes.content}>
        <Typography className={classes.subheader} variant="body2">
          {t('privacy-statement.content.subheader-disclaimer')}
        </Typography>
        <Typography variant="body2">{t('privacy-statement.content.paragraph-disclaimer')}</Typography>
        <Typography className={classes.subheader} variant="body2">
          {t('privacy-statement.content.subheader1')}
        </Typography>
        <Typography variant="body2">{t('privacy-statement.content.paragraph1a')}</Typography>
        <Typography className={classes.subheader} variant="body2">
          {t('privacy-statement.content.subheader2')}
        </Typography>
        <Typography variant="body2">{t('privacy-statement.content.paragraph2a')}</Typography>
        <Typography className={classes.subheader} variant="body2">
          {t('privacy-statement.content.subheader3')}
        </Typography>
        <Typography variant="body2">{t('privacy-statement.content.paragraph3a')}</Typography>
        <Typography className={classes.subheader} variant="body2">
          {t('privacy-statement.content.subheader4')}
        </Typography>
        <Typography variant="body2">{t('privacy-statement.content.paragraph4a')}</Typography>
        <Typography className={classes.subheader} variant="body2">
          {t('privacy-statement.content.subheader5')}
        </Typography>
        <Typography variant="body2">{t('privacy-statement.content.paragraph5a')}</Typography>
        <Typography className={classes.subheader} variant="body2">
          {t('privacy-statement.content.subheader6')}
        </Typography>
        <Typography variant="body2">{t('privacy-statement.content.paragraph6a')}</Typography>
        <Typography className={classes.subheader} variant="body2">
          {t('privacy-statement.content.subheader7')}
        </Typography>
        <Typography variant="body2">{t('privacy-statement.content.paragraph7a')}</Typography>
        <Typography className={classes.subheader} variant="body2">
          {t('privacy-statement.content.subheader8')}
        </Typography>
        <Typography variant="body2">{t('privacy-statement.content.paragraph8a')}</Typography>
        <Typography className={classes.subheader} variant="body2">
          {t('privacy-statement.content.subheader9')}
        </Typography>
        <Typography variant="body2">{t('privacy-statement.content.paragraph9a')}</Typography>
        <Typography className={classes.subheader} variant="body2">
          {t('privacy-statement.content.subheader10')}
        </Typography>
        <Typography variant="body2">{t('privacy-statement.content.paragraph10a')}</Typography>

        <Typography className={classes.paragraphLastChanged} variant="body2">
          {getLastModifiedText()}
        </Typography>
      </Box>
    </Container>
  );
};

export default PrivacyStatementContent;
